import React from "react";
import { FormattedMessage } from "react-intl";
import { L10nId } from ".";
import { intl, IntlValueType } from "./TypedIntl";

interface Props {
  id: L10nId;
  values?: { [key: string]: IntlValueType };
}

export class TypedFormattedMessage extends React.Component<Props, {}> {
  render() {
    return <FormattedMessage id={this.props.id.toString()} values={this.props.values} />;
  }
}

export const TypedHTMLFormattedMessage = (props: Props) => {
  return <span dangerouslySetInnerHTML={{ __html: intl.formatMessage(props.id, props.values) }} />;
};
